import type { ButtonProps } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';

import React from 'react';
import { Check } from 'iconoir-react';

interface FilterMenuItemProps
  extends Omit<
    ButtonProps,
    'variant' | 'colorPalette' | 'justifyContent' | 'w' | 'size' | 'px' | 'py' | 'fontWeight'
  > {
  children: React.ReactNode;
  onClick: () => void;
  isSelected: boolean;
}

export const FilterMenuItem: React.FC<FilterMenuItemProps> = ({
  children,
  onClick,
  isSelected,
  ...restButtonProps // Allow passing other ButtonProps like isDisabled
}) => {
  return (
    <Button
      variant="ghost"
      colorPalette="gray"
      bg={isSelected ? 'softCream' : 'transparent'}
      _hover={{ bg: 'softCream' }}
      color="primary.900"
      justifyContent="space-between"
      onClick={onClick}
      w="100%"
      size="sm"
      px={1.5}
      py={1}
      height="fit-content"
      minH="32px"
      rounded="md"
      fontWeight="normal"
      fontSize="sm"
      {...restButtonProps} // Spread remaining props
    >
      {/* Render the children passed to the component (e.g., Flex with Avatar/Text) */}
      {children}
      {/* Conditionally render the checkmark */}
      {isSelected && <Check width={16} height={16} />}
    </Button>
  );
};
